import React, { Component } from "react";
import { connect } from "react-redux";
/*import { Link } from "react-router-dom";*/
import CartLine from "./CartLine";
import { utils } from "../common/utils";
import { withTranslation } from 'react-i18next';
import ExtendedLink  from "../components/ExtendedLink";
import CurrencyFormat from '../components/CurrencyFormat';

class CartMenu extends Component {
  render() {
    const { t, cart, settings } = this.props;
    if (!cart) return <div />;
      let totalQuantityPrice = 0;
      let totalQuantities = 0;
      const cartLines = cart.lines.map(line => {
        totalQuantityPrice += line.quantity * line.product.specialPrice;
        totalQuantities += line.quantity;
      return (
        <CartLine
          key={line.product.id}
          line={line}
          isMenu={true}
          settings={settings}
        />
      );
    });

    return (
      <div className="cart" >
            <ExtendedLink to={`${settings.baseUrl}cart`}> </ExtendedLink>
        <i className="icon-bag" />
            <span className="count">{totalQuantities}</span>
            <span className="subtotal">
                <CurrencyFormat value={totalQuantityPrice} settings={settings} />
               {/* {utils.formatCurrency(totalQuantityPrice)}*/} 
        </span>
        <div className="toolbar-dropdown" style={ { overflowY: "auto", overflowX: "hidden", maxHeight: 0.8 * window.innerHeight, width: "fit-content" } }>
          {cartLines}
          <div className="toolbar-dropdown-group">
            <div className="column">
                        <span className="text-lg">{t("Total")}:</span>
            </div>
            <div className="column text-right">
                        <span className="text-lg text-medium">
                            <CurrencyFormat value={totalQuantityPrice} settings={settings} />
                           {/* {utils.formatCurrency(totalQuantityPrice)}*/}
              </span>
            </div>
          </div>
          <div className="toolbar-dropdown-group">
            <div className="column">
                        <ExtendedLink to={`${settings.baseUrl}cart`} className="btn btn-sm btn-block btn-secondary">
                            {t("View Cart")}
              </ExtendedLink>
            </div>
            <div className="column">
                        <ExtendedLink to={`${settings.baseUrl}checkout`} className="btn btn-sm btn-block btn-success">
                            {t("Checkout")}
              </ExtendedLink>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps({ cart, settings }, ownProps) {
  return { cart, settings, ...ownProps };
}

export default withTranslation()(connect(mapStateToProps, null)(CartMenu));
